import { Injectable } from '@angular/core';
import { IFeedConfigurationDataField } from '@app/Tenant/Applications/Airsweb/Services';
import { LocationAttribute } from '@app/Tenant/Applications/Airsweb/Models/location-attribute.model';

@Injectable({
	providedIn: 'root',
})
export class FeedHierarchyMapperService {
	mapToBestHierarchyFieldOrAttribute(
        dataFieldName: string,
        dataField: IFeedConfigurationDataField,
        hierarchyAttributes: LocationAttribute[],
        selectedAttributes: LocationAttribute[]	
    ): void {
		const level = this.getHierarchyLevel(dataFieldName);
		const listKey = this.getBestHierarchyListKey(dataFieldName);

		if (listKey) {
			dataField.ListKey = listKey;
			dataField.DataType = 'hierarchy';
			dataField.LocationLevel = level;
			return;
		}

		const attribute = this.getBestHierarchyAttributeKey(dataFieldName, hierarchyAttributes);
		dataField.AttributeId = attribute?.AttributeId ?? '';
        dataField.AttributeType = attribute?.AttributeType ?? '';
        dataField.MinChars = attribute?.MinChars;
        dataField.MaxChars = attribute?.MaxChars;
		dataField.DataType = 'attributes';
		dataField.LocationLevel = 'REPORTING_POINT';
        selectedAttributes[dataField.Index] = attribute; // needed for UI.
	}

	private getHierarchyLevel(dataFieldName: string): string {
		if (/\d/.test(dataFieldName)) {
			return `LEVEL${/(\d)/.exec(dataFieldName)[0]}`;
		}

		return 'REPORTING_POINT';
	}

	private getBestHierarchyListKey(dataFieldName: string): string | null {
		if (dataFieldName.toLowerCase().includes('address')) {
			return 'all_nodes_addresses';
		}

		if (
			dataFieldName.toLowerCase().includes('code') ||
			dataFieldName.toLowerCase().includes('short')
		) {
			return 'all_nodes_shortnames';
		}

		if (dataFieldName.toLowerCase().includes('name')) {
			return 'all_nodes';
		}

		return null;
	}

	private getBestHierarchyAttributeKey(
		dataFieldName: string,
		hierarchyAttributes: LocationAttribute[]
	): LocationAttribute {
		return hierarchyAttributes.find(
			(attribute) =>
				attribute.AttributeId === dataFieldName ||
				attribute.AttributeName === dataFieldName ||
                                attribute.AttributeId.toLowerCase().replace(/\s/g, '') ===
					dataFieldName.toLowerCase()
		);
	}
}

